// @ts-nocheck

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import '../App.css'
import '@fontsource/montserrat';

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: "/visits" });
  }, [navigate]);
  
  return <div></div>
}
